
let svg = `<svg width="375" height="441" viewBox="0 0 375 441" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3919_35200)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M-787.501 -10.9998C-802.235 -14.508 -821.974 -23.2673 -843.572 -34.6297C-906.408 -67.6878 -986.395 -18.2154 -975.407 51.931L-907.592 484.88C-901.495 523.809 -867.959 552.5 -828.556 552.5H558.906C591.081 552.5 620.125 533.225 632.624 503.576L747.898 230.126C768.209 181.947 737.623 127.54 685.912 119.81C620.396 110.016 532.018 96.7227 447.355 83.7264C420.21 79.5594 406.004 51.6853 385 33.991V33.991C369.461 20.9008 340.714 25.8987 310.957 31.0723C286.137 35.3875 260.614 39.8249 241.464 33.9916C234.188 31.7753 225.385 28.7165 215.659 25.3371C176.39 11.6928 122.081 -7.1777 92.5138 3.07132V3.07132C67.0127 11.911 43.3858 29.7169 16.3981 29.3929C-11.9024 29.0531 -40.0797 29.3241 -69.2156 29.6044C-89.5541 29.8001 -110.36 30.0002 -132 30.0002C-233.472 30.0002 -300.723 20.0063 -367.033 10.1523C-416.717 2.76888 -465.874 -4.53601 -528.5 -7.49976C-557.079 -8.8522 -589.719 -7.22792 -623.308 -5.55638C-680.386 -2.71597 -740.206 0.260918 -787.501 -10.9998Z" fill="#191414"/>
</g>
<defs>
<clipPath id="clip0_3919_35200">
<rect width="375" height="441" fill="white"/>
</clipPath>
</defs>
</svg>
`
// Mobile Footer background
let backgroundUrl = `url("data:image/svg+xml,${encodeURIComponent(
    `${svg}` // Replace with your SVG code
)}");`

export default backgroundUrl




